var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DSDrawer',{attrs:{"visible":_vm.visible,"title":_vm.title},on:{"close":_vm.onClose},scopedSlots:_vm._u([(_vm.$slots.footer)?{key:"footer",fn:function(){return [_vm._t("footer")]},proxy:true}:null],null,true)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }